import { API_BASE, buildQuery, request } from './api-client';
import type { AdminPaymentRow, Paginated } from '../types';

export function listUserPayments(
  userId: string,
  query: { page?: number; limit?: number; status?: string; gateway?: string; refundedOnly?: boolean },
) {
  return request<Paginated<AdminPaymentRow>>(
    `${API_BASE}/admin/users-mgmt/${userId}/payments${buildQuery(query as Record<string, unknown>)}`,
  );
}

export function refundPayment(input: { paymentId: string; amount?: number; reason: string }) {
  return request<AdminPaymentRow>(`${API_BASE}/admin/payments/refund`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
